import { DirectDataInputEntity, EMPTY_DIRECT_DATA_INPUT_ENTITY } from "domain/entity/DirectDataInput/DirectDataInputEntity";
import { DirectDataInputSearchCriteria, EMPTY_DIRECT_DATA_INPUT_SEARCH_CRITERIA } from "domain/entity/DirectDataInput/DirectDataInputSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface DirectDataInputModelDropdownOptions {
    forwarderCodeDropdownOptions: DropdownProps[],
    damageTypeDropdownOptions: DropdownProps[],
    operatingTmlDropdownOptions: DropdownProps[],
}
export interface DirectDataInputModelViewChangeState extends BaseViewChangeSate {
}

export interface DirectDataInputModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isShowSearchPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    dynamicOptions: DirectDataInputModelDropdownOptions,
    directDataInputList: DirectDataInputEntity[],
    selectedRows: DirectDataInputEntity[],
    currentRow: DirectDataInputEntity,
    currentEditRow: DirectDataInputEntity,
    searchCriteria: DirectDataInputSearchCriteria,
    forceRefresh: boolean,
    masterState: DirectDataInputModelViewChangeState,
    isSearchLoading: boolean,
}

export const EMPTY_DIRECT_DATA_INPUT_MODEL: DirectDataInputModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowSearchPanel: false,
    dynamicOptions: {
        forwarderCodeDropdownOptions: [],
        damageTypeDropdownOptions: [],
        operatingTmlDropdownOptions: []
    },
    directDataInputList: [],
    selectedRows: [],
    currentRow: { ...EMPTY_DIRECT_DATA_INPUT_ENTITY },
    currentEditRow: { ...EMPTY_DIRECT_DATA_INPUT_ENTITY },
    searchCriteria: { ...EMPTY_DIRECT_DATA_INPUT_SEARCH_CRITERIA },
    forceRefresh: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    },
    isSearchLoading: true,
}